import { render } from "./UnauthorizedRegisterOnEventForm.vue?vue&type=template&id=79d19f64&scoped=true"
import script from "./UnauthorizedRegisterOnEventForm.vue?vue&type=script&lang=js"
export * from "./UnauthorizedRegisterOnEventForm.vue?vue&type=script&lang=js"

import "./UnauthorizedRegisterOnEventForm.vue?vue&type=style&index=0&id=79d19f64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d19f64"]])

export default __exports__